import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../contexts/AuthContext";
import Select from "react-select";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/StyledElements";
import { useCourseContext } from "../../../../contexts/CoursesContext";


const SmallButton = styled.div`
  height: 30px;
  width: 24px;
  background-color: #f3f4f6; 
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a6b1;
  cursor: pointer;

  &.selected {
    background-color: var(--button-selected-bg); 
  }
  &.selected > * {
    color: var(--button-bg);

  }
`

const VerticalSeparator = styled.div`
  width: 1px;
  height: 30px;
  background-color: #eceff4;
  margin-left: 20px;
  margin-right: 20px;
`

const LevelSectionsGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

`

const LevelSectionCardWrapper = styled.div`
    position: relative;
    border: 1px solid var(--content-item-border-color);
    color: var(--main-font-color);
    width: 330px;
    background-color: var(--card-bg);
    border-radius: 5px;
    box-shadow: var(--content-item-box-shadow);
    padding: 20px 20px 0 20px;
`


const LevelSectionTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    margin-top: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    text-wrap: wrap;
`

const CourseDescription = styled.div`
    font-weight: normal;
    font-size: 16px;
    margin-top: 10px;
    font-style: italic;
    overflow: auto;
    max-height: 140px;
    height: 140px;
    margin-bottom: 10px;
`

const LevelSectionData = styled.div`
    position: relative;
    width: 330px;
    margin-left: -20px;
    font-size: 14px;
    color: #a0a6b1;
    background-color: var(--card-inset-bg);
    padding: 10px 20px;
    border-top: 1px solid var(--main-bg);
    border-bottom: 1px solid var(--main-bg);
`;

const CourseOpenLink = styled.a`
    font-size: 15px;
    color: var(--sidebar-active-item-color);
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
`;

const SearchBar = styled.div`
  width: calc(100% - 20px);
  border-radius: 5px;
  border: 1px solid var(--content-item-border-color);  
  background-color: var(--card-bg);
  padding: 10px 20px;
  box-shadow: var(--content-item-box-shadow);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const SearchBox = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid #d2d6dd;
  background-color: #f8fafb; 
  display: flex;
  align-items: center;
  padding-left: 10px;

  & * {
    color: #717886;
  }

  & input {
    height: 100%;
    border: none;
    outline: none !important;
    background: transparent;
    width: 250px;
  }

  & input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
}
`

const LevelSectionToolBarWrapper = styled.div`
  width: 300px;
  margin-left: -20px;
  height: 50px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  padding: 0;
`

const LevelSectionToolBarButton = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--main-bg);
  cursor: pointer;

  & * {
    font-size: 20px;
 }

`;

export const LevelSections = ({ courseLevel, style = {} }) => {
  const { activeUser } = useAuthContext();
  const isAdmin = activeUser?.user_type.includes("admin");
  const [filteredLevelSections, setFilteredLevelSections] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest-first")
  const [display, setDisplay] = useState("grid");
  const navigate = useNavigate();

  const { updatedCourse } = useCourseContext();

  const sortByOptions = [
    { label: "Newest First", value: "newest-first" },
    { label: "Open Date First", value: "open-date-first" },
    { label: "Open Date Last", value: "open-date-last" },
    { label: "Start Date First", value: "start-date-first" },
    { label: "Start Date Last", value: "start-date-last" },
  ]

  useEffect(() => {
    console.log("!!! FETCHING COURSES");
    setFilteredLevelSections(courseLevel?.sections || []);

    // eslint-disable-next-line
  }, [courseLevel?.sections]);


  useEffect(() => {
    if (!searchTerm) {
      setFilteredLevelSections(courseLevel?.sections || []);
      return;
    }

    setFilteredLevelSections(updatedCourse?.levels.filter((courseLevel) => {
      console.log(courseLevel.title, courseLevel.description)
      return `${courseLevel.status} ${courseLevel.title} ${courseLevel.description}`.toLowerCase().includes(searchTerm.toLowerCase())
    }))

    // eslint-disable-next-line
  }, [searchTerm, updatedCourse?.levels])

  const LevelSectionToolBar = ({ courseLevel }) => {
    return (
      <LevelSectionToolBarWrapper>
        {/* Toolbar buttons can be added here */}
        <LevelSectionToolBarButton><Icon icon="mdi:link" /></LevelSectionToolBarButton>
      </LevelSectionToolBarWrapper>
    )
  }

  const LevelSectionCard = ({ levelSection }) => {
    return (
      <LevelSectionCardWrapper key={levelSection.id}>
        <div style={{ height: "240px", minHeight: "240px" }}>
          <LevelSectionTitle
            title={`${levelSection?.section_number}. ${levelSection?.title}`}
          >{levelSection?.section_number}. {levelSection?.title}</LevelSectionTitle>
          <CourseDescription>{levelSection?.description ?? "No course level description"}</CourseDescription>
        </div>


        <LevelSectionData>
          <div>ID: {levelSection.id}</div>
          <div>PUB: {levelSection.public_id.substr(0, 8)}...</div>
          <div>Sections: {levelSection.section_count}</div>
          <div style={{ position: "absolute", right: "20px", top: "10px", fontSize: "12px", color: "#a0a6b1" }}>
            <CourseOpenLink onClick={() => {
              const { public_id } = levelSection;
              navigate(`/courselevel/${public_id}`);
            }}>
              View <Icon icon="mdi:open-in-new" style={{ marginLeft: "5px" }} />
            </CourseOpenLink>
          </div>
        </LevelSectionData>
        <LevelSectionToolBar levelSection={levelSection} />
      </LevelSectionCardWrapper>
    )
  }

  const LevelSectionsGrid = () => {
    console.log("!!! FILTERED COURSE LEVELS: ", filteredLevelSections);
    return (
      <LevelSectionsGridWrapper>
        {filteredLevelSections.map(levelSection => {
          return <div key={levelSection.id} style={{ marginRight: "24px", marginBottom: "24px" }}><LevelSectionCard levelSection={levelSection} /></div>
        })
        }
      </LevelSectionsGridWrapper>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        <div style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>Manage Levels Sections <span style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>({courseLevel?.sections.length > filteredLevelSections.length ? `${filteredLevelSections.length} of ${courseLevel?.sections.length}` : courseLevel?.sections.length})</span></div>
      </div>
      {
        isAdmin && (
          <div style={{ position: "absolute", right: "20px", top: "144px" }}>
            <Button
              onClick={() => {
                navigate(`/course/create`);
              }}
            >+ Create Level</Button>
          </div>
        )}

      <div style={{ marginTop: "24px" }}>
        <SearchBar>
          <label style={{ marginRight: "10px", color: "var(--main-font-color)" }}>Sort by: </label>
          <Select
            label="Sort by"
            placeholder="Sort By"
            name="sortby"
            value={
              sortByOptions.find(
                (sb) =>
                  sb.value === sortBy
              )
            }
            options={sortByOptions}
            onChange={(e) => {
              setSortBy(e.value);
            }}
          />
          <VerticalSeparator />

          <SmallButton className={display === "list" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("list") }}>
            <Icon icon="material-symbols:list" />
          </SmallButton>
          <SmallButton className={display === "grid" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("grid") }}>
            <Icon icon="material-symbols:grid-view-outline" />
          </SmallButton>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <SearchBox>
              <Icon icon="material-symbols:search" />
              <input value={searchTerm} type="text" onChange={(e) => {
                setSearchTerm(e.target.value);
              }} />

              {searchTerm &&
                <div style={{ cursor: "pointer" }} onClick={() => setSearchTerm("")}>
                  <Icon icon="material-symbols:x-circle" />
                </div>
              }
            </SearchBox>
          </div>
        </SearchBar>
      </div>

      {
        display === "grid" &&
        <div style={{ marginTop: "24px" }}>
          <LevelSectionsGrid />
        </div>
      }
      {/*
        display === "list" &&
        <CoursesTable
          courses={filteredLevelSections}
          onUpdated={(newCourses) => {
            setCourses(newCourses);
          }}
        />
      */}
    </div>
  );
};

export default LevelSections;
